import React from 'react';
import { fmtText, decreaseTxt } from './helper/index';
import ProductDescription from './components/product-description';

export const SummaryProductDescription = ({ description, page }) => {
  const type = description?.type;
  const hasIframe = !!page?.components?.['produto-descricao'];
  const content = type === 'string' ? fmtText(description?.content) : null;
  const maxCharacters = 232;
  const text = content?.length > maxCharacters ? `${decreaseTxt(content, maxCharacters)}` : content;
  const finalText = hasIframe ? null : text;
  const showMoreInformation = content?.length > maxCharacters || hasIframe;

  if (type !== 'string') {
    return (
      <ProductDescription description={finalText} showMoreInformation={true} textLink="Mais informações do produto" />
    );
  }

  return (
    <ProductDescription description={finalText} showMoreInformation={showMoreInformation} textLink="Mais informações" />
  );
};

export default SummaryProductDescription;
